import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { SideBarComponent } from './side-bar/side-bar.component';
import { RouterModule } from '@angular/router';
import { DashboardItemComponent } from './dashboard-item/dashboard-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { CountUpModule } from 'countup.js-angular2';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { DragDropComponent } from './drag-drop/drag-drop.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NglIconsModule, NglModalsModule, NglInputModule, NglSelectModule, NglCheckboxesModule, NglDatepickersModule, NglComboboxesModule, NglTooltipsModule, NglDropdown, NglDropdownItem, NglDropdownTrigger, NglModule } from 'ng-lightning';
import { SelectFilterComponent } from './select-filter/select-filter.component';
import { FilterComponent } from './filter/filter.component';
import { FilterComponent2 } from './filter/filter2.component';
import { ActionBarComponent } from './action-bar/action-bar.component';
import {TreeModule} from 'primeng/tree';
import {ToolbarModule} from 'primeng/toolbar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {ButtonModule} from 'primeng/button';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { CustomSelectComponent } from './custom-select/custom-select.component';
import { PTableComponent } from './p-table/p-table.component';
import { NewProductComponent } from './new-product/new-product.component';
import { AddItemComponent } from './add-item/add-item.component';
import { TableModule } from 'primeng/table';
import { SettlementComponent } from './settlement/settlement.component';
import { SelectdateComponent } from './selectdate/selectdate.component';
import { ToastModule } from 'primeng/toast';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ImageContainerComponent } from './image-container/image-container.component';
import { EditPaymentAccountComponent } from './edit-payment-account/edit-payment-account.component';
import { LocaleService } from '../services/locale/locale.service';
import { CalendarModule } from 'primeng/calendar';
import { FlagSelectorComponent } from './flag-selector/flag-selector.component';
import { TranslationFormComponent } from './translation-form/translation-form.component';


@NgModule({
  declarations: [
    HeaderComponent,
    SideBarComponent,
    DashboardItemComponent,
    BreadcrumbComponent,
    DragDropComponent,
    SelectFilterComponent,
    FilterComponent,
    FilterComponent2,
    ActionBarComponent,
    CustomSelectComponent,
    PTableComponent,
    NewProductComponent,
    AddItemComponent,
    SettlementComponent,
    SelectdateComponent,
    ResetPasswordComponent,
    ImageContainerComponent,
    EditPaymentAccountComponent,
    FlagSelectorComponent,
    TranslationFormComponent,
  ],
  exports: [
    HeaderComponent,
    SideBarComponent,
    DashboardItemComponent,
    BreadcrumbComponent,
    ActionBarComponent,
    DragDropComponent,
    SelectFilterComponent,
    FilterComponent2,
    FilterComponent,
    CustomSelectComponent,
    PTableComponent,
    AddItemComponent,
    SettlementComponent,
    ImageContainerComponent,
    EditPaymentAccountComponent,
    FlagSelectorComponent,
    TranslationFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NglIconsModule,
    TreeModule,
    ToolbarModule,
    NglCheckboxesModule,
    NglTooltipsModule,
    ToastModule,
    TranslateModule.forChild(),
    DragDropModule,
    NglModalsModule,
    NglModule,
    RadioButtonModule,
    ButtonModule,
    CalendarModule,
    NglComboboxesModule,
    NglDatepickersModule,
    NglInputModule,
    NglSelectModule,
    InfiniteScrollModule,
    CountUpModule,
    AutocompleteLibModule,
    TableModule,
    ReactiveFormsModule
  ],

  entryComponents: [NewProductComponent, SelectdateComponent, ResetPasswordComponent, EditPaymentAccountComponent],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],

})

export class ComponentsModule { }
